import FacturaVentaAPI from '@/api/venta/facturaVenta';

export default {
  namespaced: true,
  state: {
    facturas: [],
  },
  mutations: {},
  getters: {},
  actions: {
    get_factura_venta(_, id) {
      return FacturaVentaAPI.show(id);
    },
  },
};
